'use client';

import { useEffect, useState } from 'react';

// Decorative static sand pattern for prefers-reduced-motion users.
// Painted once as fixed SVG strokes — no rAF, no canvas, no movement.
// When `force` is true the reduced-motion gate is bypassed (use in fallback
// branches where the caller always wants strokes regardless of motion prefs).
export function StaticSandFallback({ force = false }: { force?: boolean } = {}) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (force) { setShow(true); return; }
    setShow(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }, [force]);
  if (!show) return null;
  return (
    <svg
      aria-hidden="true"
      width="100%"
      height="100%"
      style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0, opacity: 0.18 }}
      preserveAspectRatio="none"
      viewBox="0 0 100 100"
    >
      {Array.from({ length: 14 }).map((_, i) => (
        <path
          key={i}
          d={`M0,${10 + i * 6} Q25,${8 + i * 6} 50,${10 + i * 6} T100,${10 + i * 6}`}
          fill="none"
          stroke="rgba(74, 58, 42, 0.7)"
          strokeWidth="0.4"
        />
      ))}
    </svg>
  );
}
